import { render } from "./MessageEditor.vue?vue&type=template&id=522bd822&ts=true"
import script from "./MessageEditor.vue?vue&type=script&lang=ts"
export * from "./MessageEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__